const stringToDate = (value) =>
  typeof value === "string" ? new Date(value) : value;

export default stringToDate;
